




















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import NavBar from '../components/common/NavBar.vue';
import SearchFiltersComponent from '../components/search/SearchFilters.vue';
import SearchPagination from '../components/search/SearchPagination.vue';
import SearchResult from '../components/search/SearchResult.vue';
import SearchResultRow from '../components/search/SearchResultRow.vue';
import SearchTableHeaderSorting from '../components/search/SearchTableHeaderSorting.vue';
import PlusIcon from '../components/icons/PlusIcon.vue';
import { SearchFilters, AllSearchTableColumns } from '@/store/modules/searchInterfaces';
import SearchSortingDropdown from '@/components/search/SearchSortingDropdown.vue';
import { SearchModule } from '@/store/modules/search';
import Details from './Details.vue';
import { ProcessModule } from '@/store/modules/process';
import SelectionField from '../components/common/inputs/SelectionField.vue';
import ColumnSelectionField from '../components/common/inputs/ColumnSelectionField.vue';
import excelBtn from '@/components/search/ExcelBtn.vue';
import { CommonModule } from '@/store/modules/common';
import SearchField from '../components/common/inputs/SearchField.vue';
import InfoTooltip from '@/components/common/InfoTooltip.vue';

@Component({
  components: {
    PlusIcon,
    NavBar,
    SearchFiltersComponent,
    SearchPagination,
    SearchResult,
    SearchResultRow,
    SearchSortingDropdown,
    Details,
    SearchTableHeaderSorting,
    SelectionField,
    ColumnSelectionField,
    excelBtn,
    SearchField,
    InfoTooltip
  }
})
export default class Search extends Vue {
  @Prop({ type: Object as () => SearchFilters }) initialFilters!: SearchFilters;
  @Prop(Number) id?: number;
  clickedHashLink = false;

  lastFilterUpdate: Partial<SearchFilters> = {};

  get state() {
    return SearchModule;
  }

  columns = AllSearchTableColumns;

  async ieGoBack() {
    await this.updateFilters(this.lastFilterUpdate);
  }

  async updateFiltersAndScrollToTop(filters: Partial<SearchFilters>) {
    const search = this.lastFilterUpdate.text;
    await this.updateFilters(filters);

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  beforeRouteUpdate(to: any, from: any, next: any) {
    next(this.shouldContinueWithoutSaving());
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    next(this.shouldContinueWithoutSaving());
  }

  shouldLeaveWithoutSaving(event: BeforeUnloadEvent) {
    if (this.id && ProcessModule.hasChanged && !this.clickedHashLink) {
      const message = 'Vil du fortsætte uden at gemme?';
      event.returnValue = message;
      return message;
    }
    this.clickedHashLink = false;
  }

  shouldContinueWithoutSaving(): boolean {
    if (!this.id || !ProcessModule.hasChanged || this.clickedHashLink) {
      this.clickedHashLink = false;
      return true;
    }

    return confirm('Vil du fortsætte uden at gemme?');
  }

  updateFilters(filters: Partial<SearchFilters>) {
    this.lastFilterUpdate = filters;

    return SearchModule.assignFilters({
      page: 0,
      ...filters
    });
  }

  assignFilters(filters: Partial<SearchFilters>) {
    this.lastFilterUpdate = filters;

    SearchModule.assignFilters({
      page: 0,
      ...filters
    });
  }

  // we can't set an id directly on the input field (would be nice). Instead we set an id on a div above. Therefore we need to find the first (and only) input field in the div.
  findFirstInputElementValue(element: HTMLElement | null): string | null {
    if (!element) {
      return null;
    }

    if (element.tagName.toLowerCase() === 'input') {
      return (element as HTMLInputElement).value;
    } else {
      for (const child of element.children) {
        const result = this.findFirstInputElementValue(child as HTMLElement);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }

  async mounted() {
    (await !!this.initialFilters) ? SearchModule.assignFilters(this.initialFilters) : SearchModule.search();

    // listen for process changes (eg. on search)
    this.$watch(
      () => SearchModule.result?.processes,
      (newValue, oldValue) => {
        if (newValue != null) {
          const searchDiv = document.getElementById('searchFieldDiv');
          const search = this.findFirstInputElementValue(searchDiv);
          if (search != null && search !== '') {
            CommonModule.highlightWord(search);
          } else {
            CommonModule.removeHighlight();
          }
        }
      }
    );
  }
}
